module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-japan.11a5e061.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-japan.png
// module id = 2629
// module chunks = 11